import {
  faCheck,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Spinner } from '@/components/ui/spinner'
import { MutationIconProps, MutationIconState } from '@/types/misc'

interface Props {
  state: MutationIconProps
}

const MutationIcon: React.FC<Props> = ({ state }) => {
  if (state.state === MutationIconState.mutating) {
    return <Spinner />
  }

  if (state.state === MutationIconState.success) {
    return (
      <FontAwesomeIcon
        icon={faCheck}
        title={state.message}
        className="text-success"
      />
    )
  }

  if (state.state === MutationIconState.error) {
    return (
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        title={state.message}
        className="text-destructive"
      />
    )
  }

  return null
}

export default MutationIcon
